// @flow
/** @jsx isolateComponent */

import { Image } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';

import { useStaticAssetPath } from '../StaticAssetProvider';

type Props = {
  /** Image path */
  src: string,
};

const StaticImage = ({ src, ...props }: Props) => {
  const { buildStaticAssetUrl } = useStaticAssetPath();

  return <Image {...props} src={buildStaticAssetUrl(src)} />;
};

export default StaticImage;
